/**
 * Agrupamento do catalogo por workspace - usado pela navegacao (casca) e pelo catalogo.
 *
 * O workspace do Auth e a porta de acesso de um relatorio; para quem le, e o jeito natural de
 * achar o que procura.
 */

import type { ReportListItem } from '../api/types'

/** Valor do filtro que mostra todos os workspaces. */
export const TODOS = '__todos__'

const SEM_WORKSPACE = 'Sem workspace'

export function grupoDe(item: ReportListItem): string {
  return (item.workspace_name ?? '').trim() || SEM_WORKSPACE
}

/** Workspaces em ordem alfabetica, cada um com os seus relatorios. */
export function agrupar(itens: ReportListItem[]): Array<[string, ReportListItem[]]> {
  const mapa = new Map<string, ReportListItem[]>()
  for (const item of itens) {
    const nome = grupoDe(item)
    const atual = mapa.get(nome)
    if (atual === undefined) mapa.set(nome, [item])
    else atual.push(item)
  }
  return [...mapa.entries()].sort((a, b) => a[0].localeCompare(b[0], 'pt-BR'))
}
